module.exports = __webpack_public_path__ + "static/media/icon_success_green-bofa.0d9a7125.svg";